<!--
    预约模块
-->
<template>
  <div id="appont-fluid">
    <div id="appoint" class="appoint-box">
      <div class="appoint" :class="{appoint2:activeIndex == 1}">
        <div class="tabs">
          <div @click="()=>{activeIndex = 0}" class="tab"></div>
          <div @click="()=>{activeIndex = 1}" class="tab"></div>
        </div>
        <div v-if="activeIndex==0" class="appoint-form">
          <span class="fullInput fullInput1 mb-normal">
            <select @change="changeSeries" v-model="carType">
              <option v-for="(item,index) in carSeriesList" :key="index" :value="item.value">{{item.name}}</option>
            </select>
          </span>
          <span class="fullInput fullInput2 mb-normal">
            <input v-model="userName" type="text" placeholder="请输入姓名" />
          </span>
          <span class="fullInput mb-normal">
            <input
              v-model="userPhone"
              maxlength="11"
              type="text"
              placeholder="请输入手机号"
            />
          </span>
          <!-- <div class="appoint-item clear">
            <div
              @click="
                () => {
                  sexIndex = index;
                }
              "
              v-for="(item, index) in sexList"
              :key="index"
              class="halfInput"
              :class="{ active: index == sexIndex }"
            >
              {{ item.label }}
            </div>
          </div>
        </div> -->
          <checkbox v-model="checked"></checkbox>
          <div @click="submit" class="submit">即刻出发</div>
        </div>
        <div v-if="activeIndex==1" class="copyBox-fluid">
          <img @click="copyFn" src="https://source.qunarzz.com/site/images/wns/20220427-shijianchen-copy.png" class="copyBox" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import checkbox from "./checkbox";
import ruleDialog from "./dialog/rule/index";
import lotteryDialog from "./dialog/lottery/index";
import loginDialog from "@/components/login/index";
import lightPoint from "./lightPoint";
import giftDialog from "./dialog/gift/index";
import copy from 'copy-to-clipboard'
export default {
  components: {
    checkbox,
    lightPoint,
  },
  data() {
    return {
      userName: "",
      userPhone: "",
      activeIndex:0,
      storeCode: "",
      carType: "",
      checked: true,
      verifyCode: "",
      cityCode: "",
      sexIndex: 0,
      sexList: [
        {
          label: "先生",
        },
        {
          label: "女士",
        },
      ],
      provinceCode: "",
      defaultSelectCar: { name: "请选择意向车型", value: "" },
      defaultSelectProvince: { name: "请选择省份", value: "" },
      defaultSelectCity: { name: "请选择城市", value: "" },
      defaultSelectAgent: { name: "请选择经销商", value: "" },
      carSeriesList: [],
      provinceList: [],
      cityList: [],
      codeUrl: "",
      storeList: [],
    };
  },
  created() {
    this.provinceList = [this.defaultSelectProvince];
    this.carSeriesList = [];
    this.cityList = [this.defaultSelectCity];
    this.storeList = [this.defaultSelectAgent];
    this.getCodeUrl();
    this.initCarSeriesList().then(()=>{
      this.initProvinceList();
    }); 
    // hysdk.app.getAppInfo({
    //   hybridId: "qrn_demo_android",
    //   success: function (data) {
    //     alert("success:" + JSON.stringify(data));
    //   },
    //   fail: function (err) {
    //     alert("error:" + JSON.stringify(err));
    //   },
    // });
  },
  methods: {
    copyFn(){
      copy("xcfamily@volvocars.com");
      this.$dialog.alert({
        message: "复制成功",
      });
    },
    initCarSeriesList() {
      return new Promise((resolve)=>{
        this.$axios.get("/keepInfo/model").then((res) => {
        let carSeriesList = [];
        this.carType = res.data[0].modelName;
        res.data.forEach((item) => {
          carSeriesList.push({
            name: item.modelName,
            value: item.modelName,
            modelCode:item.modelName
          });
        });
        this.carSeriesList = carSeriesList;
        resolve();
      });
      })
    },
    showRule() {
      ruleDialog();
    },
    lottery() {
      this.$axios
        .post("/lottery/draw", {
          vehicleKeepInfoKey:
            localStorage.getItem("volvo07/vehicleKeepInfoKey") || "",
        })
        .then((res) => {
          if (res.code == 400) {
            loginDialog({
              callback: () => {
                this.lottery();
              },
            });
          } else if (res.code != 200) {
            this.$dialog.alert({
              message: res.message,
            });
          } else {
            /* 处理中奖之后的逻辑 */
            let data = res.data[0];
            giftDialog({
              giftTip: data.prizeCode,
              couponCode: data.couponCode,
            });
          }
        });
    },
    ruleDialog() {
      ruleDialog();
    },
    changeSeries(e) {
      this.provinceCode = "";
      this.cityCode = "";
      this.storeCode = "";
      this.carType = e.target.value;
    },
    verifyForm() {
      return new Promise((resolve) => {
        var reg = /^1[3456789]\d{9}$/gi;
        let dialog = this.$dialog;
        if (!this.checked) {
          dialog.alert({
            message: "请勾选隐私政策",
          });
        } else if (this.userName == "") {
          dialog.alert({
            message: "请输入姓名",
          });
        } else if (this.userPhone == "") {
          dialog.alert({
            message: "请输入手机号",
          });
        } else if (!reg.test(this.userPhone)) {
          dialog.alert({
            message: "请输入正确的手机号",
          });
        } else {
          resolve();
        }
      });
    },
    filterCode() {
      let code = "";
      this.carSeriesList.forEach((item, index) => {
        if (item.name == this.carType) {
          code = item.modelCode;
        }
      });
      return code;
    },
    getCodeUrl() {
      this.codeUrl =
        "http://qapi.qunar.com/api/captcha/getImage?device=1&k=RgjR0Yzc&appId=dmf_ad_peri&idx=1&" +
        new Date().getTime();
    },
    submit() {
      this.verifyForm().then(() => {
        let params = {
          phone: this.userPhone,
          name: this.userName,
          modelName: this.carType
        };
        this.$axios
          .post("/keepInfo/keepInfoWithOutAgent", params)
          .then((res) => {
            if (res.code == 200) {
              this.$dialog.alert({
                message: "提交成功",
              });
            } else {
              this.$dialog.alert({
                message: res.message,
              });
            }
          });
      });
    },
    initProvinceList() {
      this.$axios.get("/keepInfo/provinces").then((res) => {
        let provinceList = [this.defaultSelectProvince];
        res.data && res.data.forEach((item) => {
          provinceList.push({
            name: item,
            value: item,
          });
        });
        this.provinceList = provinceList;
      });
    },
    initCityList(province) {
      this.$axios.get("/keepInfo/cities?province=" + province).then((res) => {
        let cityList = [this.defaultSelectCity];
        res.data.forEach((item) => {
          cityList.push({
            name: item,
            value: item,
          });
        });
        this.cityList = cityList;
      });
    },
    initStoreList(provinceCode, cityCode) {
      this.$axios
        .get("/keepInfo/agents?province=" + provinceCode + "&city=" + cityCode)
        .then((res) => {
          let storeList = [this.defaultSelectAgent];
          res.data.forEach((item) => {
            storeList.push({
              name: item,
              value: item,
            });
          });
          this.storeList = storeList;
        });
    },
    changeProvince(e) {
      this.cityCode = "";
      this.storeCode = "";
      this.provinceCode = e.target.value;
      this.initCityList(this.provinceCode);
    },
    changeCity(e) {
      this.storeCode = "";
      this.cityCode = e.target.value;
      this.initStoreList(this.provinceCode, this.cityCode);
    },
  },
};
</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.appoint-box {
  position: relative;
  .ruleBtn {
    position: absolute;
    right: 0;
    top: 0;
    width: 79px;
    height: 29px;
  }
  border-top: 1px solid transparent;
  .title {
    margin-left: 35px;
    margin-right: 10px;
    position: relative;
    top: 12px;
    width: calc(100% - 120px);
  }
}
.rule-btn {
  border: 1px solid #1c3855;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  padding-left: 5px;
  padding-right: 15px;
  padding-top: 6px;
  padding-bottom: 6px;
  border-left: 0;
  font-size: 16px;
  position: absolute;
  left: 0;
  top: 3px;
  z-index: 10;
  cursor: pointer;
}
#appoint {
  background-size: 100% auto;
  height: 483px;
}
#appont-fluid {
  height: 696px;
}
.tabs{
  height:45px;
  width:100%;
  display: flex;
  align-items: center;
  .tab{
    flex:1;
    cursor: pointer;
    height:100%;
  }
}
.copyBox-fluid{
  position: relative;
  .copyBox{
    width:276px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top:200px;
  }
}
.appoint {
  height: 384px;
  position: relative;
  width: calc(100% - 48px);
  margin-left: 20px;
  background: url(https://source.qunarzz.com/site/images/wns/20220429-shijianchen-card-1.png)
    no-repeat;
  background-size: 100% auto;
  box-sizing: border-box;
  &.appoint2{
    background-image:url(https://source.qunarzz.com/site/images/wns/20220429-shijianchen-card-2.png);
  }
  &-form {
    padding-top: 1px;
    width: 265px;
    margin-left: auto;
    margin-right: auto;
    margin-top:20px;
    input,
    select {
      display: block;
      border: none;
      outline: none;
      height: 37px;
      background-color: transparent;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      padding-left: 10px;
      padding-right: 20px;
      color: #fff;
      font-size: 12px;
    }
    input::placeholder,
    select {
      color: #fff;
    }
    .fullInput1 {
      padding-left: 0 !important;
      background-image: none !important;
      position: relative;
      select{
        width:100%;
      }
      &:after {
        content: "";
        display: block;
        background: url(https://source.qunarzz.com/site/images/wns/20220427-shijianchen-arrow.png)
          no-repeat;
        background-size: 100% auto;
        background-position-y: center;
        width: 7px;
        height: 30px;
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -15px;
      }
    }
    .fullInput {
      padding-left: 32px;
      width: 265px;
      display: block;
      height: 37px;
      border-radius: 7px;
      background: url("https://source.qunarzz.com/site/images/wns/20220429-shijianchen-phone.png")
        no-repeat;
      background-size: 10px auto;
      background-position: left center;
      background-position-x: 15px;
      border: 1px solid #ffffff;
    }
    .fullInput2{
      background-image:url(https://source.qunarzz.com/site/images/wns/20220429-shijianchen-name.png);
      background-size: 14px auto;
      background-position-x: 12px;
    }
    .halfInput {
      width: 160px;
      float: left;
      padding-left: 50px;
    }
    .mr-half {
      margin-right: 14px;
    }
    .mb-normal {
      margin-bottom: 28px;
    }
  }
  &-item {
    margin-bottom: 20px;
    > div {
      height: 31px;
      background-color: #dcdde0;
      color: #3e3937;
      text-align: center;
      line-height: 31px;
      border-radius: 16px;
      padding-left: 0 !important;
      &.active {
        background-color: #73a8bf;
        color: #fff;
      }
      &:nth-child(2) {
        float: right;
      }
    }
  }
}
.submit {
  width: 267px;
  height: 35px;
  margin-top: 21px;
  margin-left: auto;
  margin-right: auto;
  z-index: 10;
  background-color: #fff;
  color:#1D2C43;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
}
.smscode {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-box-align: center;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  -webkit-text-size-adjust: center;
  margin-top: 15px;
  padding-left: 0 !important;
  width: calc(100% - 30px);
  margin-left: auto;
  margin-right: auto;
  &-lf {
    width: 156px;
    height: 35px;
    border: 1px solid #b9b9b9;
    text-align: center;
    background-color: #fff0c2;
    border-radius: 3px;
    input {
      text-align: center;
      padding-left: 0;
      width: 162px;
    }
  }
  &-rt {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    -webkit-box-align: center;
    .codeNum {
      width: 93px;
      height: 35px;
      overflow: hidden;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      -webkit-box-align: center;
      justify-content: center;
      -webkit-text-size-adjust: center;
      img {
        height: 35px;
        display: block;
      }
    }
    .refresh {
      width: 20px;
      height: 20px;
      margin-left: 10px;
    }
  }
}
</style>